export const euiDb = [
  {
    article: "4521046",
    name: "Розетка з/к б/ш в/з белая",
    group: "Розетка винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 3]
  },
  {
    article: "4521047",
    name: "Розетка з/к з/ш в/з белая",
    group: "Розетка винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 3]
  },
  {
    article: "4521051",
    name: "Розетка 45град з/к б/ш в/з белая",
    group: "Розетка 450 винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "4521052",
    name: "Розетка 45град з/к з/ш в/з белая",
    group: "Розетка 450 винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "4521054",
    name: "Розетка з/к б/ш б/з белая",
    group: "Розетка безвинтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1]
  },
  {
    article: "4521055",
    name: "Розетка з/к з/ш б/з белая",
    group: "Розетка безвинтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1]
  },
  {
    article: "4521058",
    name: "Розетка 45град з/к б/ш б/з белая",
    group: "Розетка 450 безвинтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 2]
  },
  {
    article: "4521059",
    name: "Розетка 45град з/к з/ш б/з белая",
    group: "Розетка 450 безвинтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 2]
  },
  {
    article: "4521341",
    name: "Заглушка (1 мод.) белая",
    group: "Заглушка",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "4521342",
    name: "Заглушка (2 мод.) белая",
    group: "Заглушка",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "CKK-40D-PD2-K01",
    name: "ВК4-22-00-П Выключатель проходной (переключатель) двухклавишный (на 2 модуля) ПРАЙМЕР белый IEK",
    group: "Переключатель 2 кл.",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "CKK-40D-PO2-K01",
    name: "ВК4-21-00-П Выключатель проходной (переключатель) одноклавишный (на 2 модуля) ПРАЙМЕР белый IEK",
    group: "Переключатель 1 кл.",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "CKK-40D-RI1-K01",
    name: "РКИ-10-00-П Розетка компьютерная RJ-45 UTP кат.5e (на 1 модуль) ПРАЙМЕР белая IEK",
    group: "Розетка компьютерная",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "CKK-40D-RI2-K01",
    name: "РКИ-20-00-П Розетка компьютерная RJ-45 UTP кат.5e (на 2 модуля) ПРАЙМЕР белая IEK",
    group: "Розетка компьютерная",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "CKK-40D-RSB2-K01-K",
    name: "РКС-20-20-П-К Розетка без з/к 2к (2 мод) ПРАЙМЕР белая IEK",
    group: "Розетка без заземляющего контакта",
    modulesNumber: "2",
    assortmentGroup: [1, 3]
  },
  {
    article: "CKK-40D-RSZB2-K01-K",
    name: "РКС-20-30-П-К Розетка с з/к 2к (2 мод) ПРАЙМЕР белая IEK",
    group: "Розетка винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 3]
  },
  {
    article: "CKK-40D-RT1-K01",
    name: "РКФ-10-00-П Розетка телефонная RJ-11 кат.3 (на 1 модуль) ПРАЙМЕР белая IEK",
    group: "Розетка телефонная",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "CKK-40D-RT2-K01",
    name: "РКФ-20-00-П Розетка телефонная RJ-11 кат.3 (на 2 модуля) ПРАЙМЕР белая IEK",
    group: "Розетка телефонная",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "CKK-40D-VD2-K01",
    name: "ВК1-22-00-П Выключатель двухклавишный (на 2 модуля) ПРАЙМЕР белый IEK",
    group: "Выключатель 2 кл.",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "CKK-40D-VO2-K01",
    name: "ВКО-21-00-П Выключатель одноклавишный (на 2 модуля) ПРАЙМЕР белый IEK",
    group: "Выключатель 1 кл.",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "CKK-40D-Z01-K01",
    name: "ЗК-00-01-П Заглушка на 1 модуль белая IEK",
    group: "Заглушка",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-PLK-0-1-K01",
    name: "PRIMER Панель лицевая Keystone (1 мод.) бел. IEK",
    group: "Панель keystone",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-PLK-0-2-K01",
    name: "PRIMER Панель лицевая Keystone (2 мод.) бел. IEK",
    group: "Панель keystone",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-PLK2-0-2-K01",
    name: "PRIMER Панель лицевая Keystone (2м/2вх) бел. IEK",
    group: "Панель keystone",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RH-0-1-K01",
    name: "PRIMER РКМ-10-00-П Розетка HDMI M/M (1 мод.) бел. IEK",
    group: "Розетка HDMI",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RH-0-2-K01",
    name: "PRIMER РКМ-20-10-П Розетка HDMI M/M (2 мод.) бел. IEK",
    group: "Розетка HDMI",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RI-0-1-C06U-K01",
    name: "PRIMER РКИ-10-00-П-6 Розетка RJ45 кат.6 (1 мод.) бел. IEK",
    group: "Розетка компьютерная",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RI-0-2-1C06U-K01",
    name: "PRIMER РКИ-20-00-П-6 Розетка RJ45 кат.6 (2 мод.) бел. IEK",
    group: "Розетка компьютерная",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RI-0-2-2C06U-K01",
    name: "PRIMER РКИ-22-00-П-6 Розетка RJ45 кат.6 (2м/2вх) бел. IEK",
    group: "Розетка компьютерная",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RI-0-2-2C5EU-K01",
    name: "PRIMER РКИ-22-00-П-5 Розетка RJ45 кат.5E (2м/2вх) бел. IEK",
    group: "Розетка компьютерная",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RSZH-2-2-45-K01",
    name: "PRIMER РКС-20-30-П-45 Розетка 45град з/к з/ш в/з бел. IEK",
    group: "Розетка 450 винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RSZH-2-2-K01",
    name: "PRIMER РКС-20-30-П-К Розетка з/к з/ш в/з бел. IEK",
    group: "Розетка винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 3]
  },
  {
    article: "PR-KK40D-RU-0-1-A3-K01",
    name: "PRIMER РКЮ-10-00-П Розетка USB A 3.0 (1 мод.) бел. IEK",
    group: "Розетка USB (инф.)",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RU-0-2-AA-K01",
    name: "PRIMER РКЮ-23-40-П Розетка USB A+A 4,2А (2 мод.) бел. IEK",
    group: "Розетка USB (зарядка)",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RU-0-2-AC-K01",
    name: "PRIMER РКЮ-25-40-П Розетка USB A+C 4,2А (2 мод.) бел. IEK",
    group: "Розетка USB (зарядка)",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RV-0-1-K01",
    name: "PRIMER РКМ-10-20-П Розетка VGA M/M (1 мод.) бел. IEK",
    group: "Розетка VGA",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RV-0-2-K01",
    name: "PRIMER РКМ-20-20-П Розетка VGA M/M (2 мод.) бел. IEK",
    group: "Розетка VGA",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-VO-2-1-K01",
    name: "PRIMER ВК0-11-00-П Выкл. одноклав. (1 мод.) бел. IEK",
    group: "Выключатель 1 кл.",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-VPO-2-1-K01",
    name: "PRIMER ВК4-11-00-П Выкл. прох. одноклав. (1 мод.) бел. IEK",
    group: "Переключатель 1 кл.",
    modulesNumber: "1",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-Z-2-K01",
    name: "PRIMER ЗК-00-02-П Заглушка (2 мод.) бел. IEK",
    group: "Заглушка",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "4520340",
    name: "Ключ для розетки с блокировкой",
    group: "Розетка с блокировкой",
    modulesNumber: "0",
    assortmentGroup: [1]
  },
  {
    article: "4525046",
    name: "Розетка з/к б/ш в/з красная",
    group: "Розетка винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 3]
  },
  {
    article: "4525047",
    name: "Розетка з/к з/ш в/з красная",
    group: "Розетка винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 3]
  },
  {
    article: "4525051",
    name: "Розетка 45град з/к б/ш в/з красная",
    group: "Розетка 450 винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "4525052",
    name: "Розетка 45град з/к з/ш в/з красная",
    group: "Розетка 450 винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "4525054",
    name: "Розетка з/к б/ш б/з красная",
    group: "Розетка безвинтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1]
  },
  {
    article: "4525055",
    name: "Розетка з/к з/ш б/з красная",
    group: "Розетка безвинтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1]
  },
  {
    article: "4525058",
    name: "Розетка 45град з/к б/ш б/з красная",
    group: "Розетка 450 безвинтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 2]
  },
  {
    article: "4525059",
    name: "Розетка 45град з/к з/ш б/з красная",
    group: "Розетка 450 безвинтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 2]
  },
  {
    article: "4525061",
    name: "Розетка з/к з/ш б/з бл. красная",
    group: "Розетка с блокировкой",
    modulesNumber: "2",
    assortmentGroup: [1]
  },
  {
    article: "CKK-40D-RSK2-K04-K",
    name: "РКС-20-22-П-К Розетка без з/к 2к (2 мод) ПРАЙМЕР красная IEK",
    group: "Розетка без заземляющего контакта",
    modulesNumber: "2",
    assortmentGroup: [1, 3]
  },
  {
    article: "CKK-40D-RSZK2-K04-K",
    name: "РКС-20-32-П-К Розетка с з/к 2к (2 мод) ПРАЙМЕР красная IEK",
    group: "Розетка винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 3]
  },
  {
    article: "PR-KK40D-RSZH-2-2-45-K04",
    name: "PRIMER РКС-20-32-П-45 Розетка 45град з/к з/ш в/з красн. IEK",
    group: "Розетка 450 винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 2, 3]
  },
  {
    article: "PR-KK40D-RSZH-2-2-K04",
    name: "PRIMER РКС-20-32-П-К Розетка з/к з/ш в/з красн. IEK",
    group: "Розетка винтовые зажимы",
    modulesNumber: "2",
    assortmentGroup: [1, 3]
  }
]



// WEBPACK FOOTER //
// ./src/react/constants/hatch/euiDb.js